"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Phone = void 0;
const react_1 = __importStar(require("react"));
const input_1 = __importDefault(require("react-phone-number-input/input"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const use_form_1 = __importDefault(require("../../../form/use-form"));
const styles_1 = require("../../../styles");
const styles_2 = require("./styles");
const constants_1 = require("../../../constants");
const Phone = ({ path, inputPath }) => {
    const [{ config: phoneInputConfig }] = (0, use_form_1.default)(inputPath);
    // phone input configs
    const [state, phoneActions] = (0, use_form_1.default)(path, {
        eventProcessor: (phone) => phone,
        type: 'phone'
    });
    // see onChange prop for why this is needed
    const phoneValueRef = (0, react_1.useRef)(state.value || '');
    // see onChange prop for why this is needed
    const onChangeDebounce = (0, react_1.useMemo)(() => (0, debounce_1.default)((phone) => {
        // We have to use this as both a controlled and uncontrolled input due to issues with
        // `react-phone-number-input` not properly calling onChange when a value is deleted
        // and re-added. Updating the value ref synchronously fixes this problem. However,
        // it can lead to a race condition where the user can queue up another onChange on
        // the browser event queue, leading to an infinite loop of cycling between two values.
        // To avoid this, we debounce the setting of the ref value so that only the latest input
        // during rapid typing gets updated, and any input while the function is executing won't get
        // queued up until the previous set has been processed to avoid looping.
        phoneValueRef.current = phone;
        phoneActions.onChange(phone || '');
    }, constants_1.DEBOUNCE_TIME), [phoneActions]);
    const descriptionId = `${path}-phone-number-description`;
    const { config: { placeholder, countryFormat = 'US', ariaDescription = 'Please enter a 10 digit US phone number. If entry is a valid US phone the number will be formatted automatically.', autoComplete }, errors } = state;
    const label = state.config.label || phoneInputConfig.label;
    const isRequired = state.config.isRequired || phoneInputConfig.isRequired;
    return (react_1.default.createElement(styles_2.PhoneFieldStyles, { flexGrow: 4 },
        react_1.default.createElement(styles_1.FieldErrorWrapper, { errors: errors, style: { position: 'relative' } },
            react_1.default.createElement(styles_1.StyledPhoneInput, { hasError: !!errors.length },
                react_1.default.createElement(input_1.default, { name: path, path: path, "aria-describedby": descriptionId, "aria-label": label, "aria-required": isRequired, "aria-invalid": Boolean(errors.length), "data-testid": path, placeholder: placeholder, showCountrySelect: false, value: phoneValueRef.current, country: countryFormat, initialValueFormat: "national", onChange: onChangeDebounce, onBlur: phoneActions.displayErrors, errors: errors, autoComplete: autoComplete }),
                react_1.default.createElement(styles_1.HiddenAriaDescription, { id: descriptionId }, ariaDescription),
                state.errors.map((error) => (react_1.default.createElement(styles_1.ErrorMessage, { key: error }, error)))))));
};
exports.Phone = Phone;
//# sourceMappingURL=phone-field.js.map